const exceedUsageLimitMessages = [
    {
        tool: "resume_upload",
        message:
            "You can only upload 3 resume with the free plan. Upgrade to Premium to upload unlimited resumes!",
    },
    {
        tool: "bullet_generation_tool",
        message:
            "You can only generate 5 bullet points with the free plan. Upgrade to Premium to generate unlimited bullet points!",
    },
    {
        tool: "cover_letter",
        message:
            "You can only generate 3 cover letter with the free plan. Upgrade to Premium to generate unlimited cover letter!",
    },
    {
        tool: "network_tool",
        message:
            "You can only generate 1 networking message with the free plan. Upgrade to Premium to generate unlimited networking messages!",
    },
    {
        tool: "interview_ai",
        message: "InterviewAI is only available to premium user. Upgrade to Premium to easily pass interviews!",
    },
    {
        tool: "job_tracker",
        message: "Bring speed, quality, and structure to your job search"
    },
    {
        tool: "learning_hub",
        message: "🎉 We're introducing a subscription model with AutoApplyAI, Learning Hub and more! Don't worry, we're still offering a Forever Free Plan, ensuring a perfect fit for every need."
    }
];

const ROUTE_NAME_TO_FEATURE_MAP = {
    "resumes": 'resume_upload',
    "resumes.edit": 'resume_upload',
    "resumes.preview": 'resume_upload',
    "cover-letters.index": 'cover_letter',
    "cover-letters.edit": 'cover_letter',
    "auto-apply": 'auto_apply',
    "auto-apply-search-history": 'auto_apply',
    "job-tracker": 'auto_apply',
    "auto-apply-jobs": 'auto_apply',
    "job-tracker-data-management": 'auto_apply',
    "interview-ai": 'interview_ai',
    "interview-ai-interviews": 'interview_ai',
    "interview-ai-create": 'interview_ai',
    "interview-ai-interview": 'interview_ai',
    "interview-ai-complete": 'interview_ai',
    "networking-tool": 'network_tool',
    "resume-tool": 'resume_upload',
    "networking-tool-favorites": 'network_tool',
}

const FEATURE_EXCEED_MESSAGE_MAP = {
    resume_upload: "You can only upload 3 resume with the free plan. Upgrade to Premium to upload unlimited resumes!",
    bullet_generation_tool: "You can only generate 5 bullet points with the free plan. Upgrade to Premium to generate unlimited bullet points!",
    cover_letter: "You can only generate 3 cover letter with the free plan. Upgrade to Premium to generate unlimited cover letter!",
    network_tool: "You can only generate 1 networking message with the free plan. Upgrade to Premium to generate unlimited networking messages!",
    interview_ai: "InterviewAI is only available to premium user. Upgrade to Premium to easily pass interviews!",
    resume_scorer: "Upgrade to Premium to see the breakdown of your resume score and tips on how to improve it!",
    job_tracker: "It seems you have reached your limit of 30 jobs in JobTrackerAI. Please upgrade to Premium to track more jobs.",
    learning_hub: "🎉 We're introducing a subscription model with AutoApplyAI, Learning Hub and more! Don't worry, we're still offering a Forever Free Plan, ensuring a perfect fit for every need.",
    find_email: "🎉 In order to enjoy the full capabilities of Find Emails and find unlimited emails subscribe. Learn more.",
    cold_email: "🎉 In order to enjoy the full capabilities of Cold Emailing and generate unlimited emails subscribe. Learn more."
};

const TOOLS = Object.keys(FEATURE_EXCEED_MESSAGE_MAP)

const PLAN_SUBSCRIPTION_PRICE = 1999

export {
    exceedUsageLimitMessages,
    FEATURE_EXCEED_MESSAGE_MAP,
    ROUTE_NAME_TO_FEATURE_MAP,
    TOOLS,
    PLAN_SUBSCRIPTION_PRICE
}
